import React, {useState, useRef} from 'react';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import {Table, Button, Form, Tag, Skeleton, Col, Row, Alert, Modal} from 'antd';
import {DownOutlined, UpOutlined} from '@ant-design/icons';
import EditableCell, {
  resetAttendanceDependentOptions,
} from '../../CommonComponents/EditableCell';
import './style.css';
import ConfirmationAction from '../../CommonComponents/PaymentConfirmationAction';
import {useNavigate, useParams} from 'react-router-dom';
import {useEffect} from 'react';
import {
  formValueChangeHandler,
  formatCurrencyByLocalChapter,
  validatePaymentPrice,
  scrollAndFocusFormErrorField,
  getRequiredAttendeeFieldErrors,
} from '../../../Util/commonUtility';
import AddAttendeeeComponent from '../../CommonComponents/AttendeeAddComponent';
import CustomCollapse from '../../CommonComponents/CommonAccordian';
import AdminActionsDropdown from '../../CommonComponents/AdminActionsDropdown/AdminActionsDropdown';
import NavigationComponent from '../../CommonComponents/CommonBackButton';
import SponsorOptionPageHeroText from '../../CommonComponents/SponsorOptionPageHeroText';
import PromotionalCodeInputCart from '../../CommonComponents/CouponCodeInputCart';
import {useThrottle} from '../../../hooks/useThrottle';
import {useDispatch} from 'react-redux';
import {FETCH_ERROR} from '../../../Constant/ActionTypes';
import WaitingList from './WaitingList';
import useLocalization from '../../../Localization';
import {LANGUAGES} from '../../../Localization/LanguageContext';
import {
  buildTallyFormUrl,
  getPendingQualificationAttendees,
  getRegistrationOptionMeta,
  isTallyFormSubmittedMessage,
  toTallyEmbedUrl,
} from '../../../Util/tallyQualification';
import {
  pollQualificationStatus,
  fetchAttendeesForQualificationCheck,
} from '../../../Store/Actions/eventRegister';

const AddAttendeeComponent = ({
  allEventOptionsFoodData,
  allEventOptionsRegistrationData,
  inPersonRemaining,
  AddAttendee,
  eventType,
  eventAvailableForWebcast,
  attendeesData,
  setAttendeesData,
  deleteAttendeeById,
  editAttendeeById,
  totalCartPrice,
  eventName,
  allAttendeesData,
  allRegistrationWaitingList,
  paymentByUserRegistration,
  applyCouponCode,
  appliedCartCoupon,
  eventLocalChapterData,
  eventISOnline,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {id} = useParams();
  const {ApplicationString, currentLanguage} = useLocalization();
  const [editingKey, setEditingKey] = useState('');
  const [form] = Form.useForm();
  const [isAddAttendee, setIsAddAttendee] = useState(false);
  const [disableAttendeeClicks, setDisableAttendeeClicks] = useState(false);
  const [disablePaymentClicks, setDisablePaymentClicks] = useState(false);
  const [disableEditClicks, setDisableEditClicks] = useState(false);
  const [isSavingAttendee, setIsSavingAttendee] = useState(false);
  const isEditing = (record) => record.id === editingKey;
  const [loading, setLoading] = useState(false);
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState(false);
  // null = user has not chosen yet (radio shows nothing selected). Defaulted by
  // event capability below; only left null when the user genuinely has a choice.
  const [attendeeInPersonChecked, setAttendeeInPersonChecked] = useState(null);
  const [addAttendeeAccordionOpen, setAddAttendeeAccordionOpen] =
    useState(false);
  const [qualificationConfirming, setQualificationConfirming] = useState(false);
  const [tallySession, setTallySession] = useState(null);
  const tallySessionRef = useRef(null);
  const confirmingLockRef = useRef(false);
  const sessionIdRef = useRef(0);

  localStorage.setItem('isUserLoginFromAddAttendee', id);

  const getDefaultAttendanceSelection = () => {
    if (!eventType) {
      return null;
    }
    if (eventType?.toLowerCase() === 'webcast' || eventISOnline) {
      return false;
    }
    if (eventAvailableForWebcast?.isAvailable) {
      return null;
    }
    return true;
  };

  // Default the attendance type by event capability. When the event is
  // webcast/online-only, force Webcast; when webcast is unavailable, force
  // In-Person; otherwise leave unselected so the user must choose.
  useEffect(() => {
    setAttendeeInPersonChecked(getDefaultAttendanceSelection());
  }, [eventType, eventISOnline, eventAvailableForWebcast?.isAvailable]);

  const handleAttendeeInPersonChange = (e) => {
    setAttendeeInPersonChecked(e.target.value === 'webcast' ? false : true);
    if (e.target.value === 'webcast') setOpenConfirmationPopup(true);
  };
  const newAttendee = {
    id: '',
    name: '',
    email: '',
    eventId: '',
    price: '',
    registration_option: '',
    food_option: '',
    attendee_department: '',
    attendee_job_title: '',
  };
  const edit = (record) => {
    const EditData = {
      ...record,
      attendee_email_confirm: record?.attendee_email
        ? record?.attendee_email
        : '',
      food_option:
        record?.food_option === ''
          ? []
          : record.event_registration_options?.food?.event_option_id ||
            'no-food',
      registration_option:
        record.event_registration_options?.registration?.event_option_id,
    };
    if (!isAddAttendee) {
      form.setFieldsValue({
        ...EditData,
      });
    }
    record.registration_type &&
      (eventType?.toLowerCase() !== 'webcast' || eventISOnline) &&
      setAttendeeInPersonChecked(
        record.registration_type?.toLowerCase() === 'webcast' ? false : true,
      );
    setEditingKey(record.id);
  };

  const cancel = () => {
    if (isSavingAttendee) return;
    if (isAddAttendee) {
      attendeesData.pop();
      setAttendeesData([...attendeesData]);
    }
    form.resetFields();
    setIsAddAttendee(false);
    setEditingKey('');
    setAttendeeInPersonChecked(getDefaultAttendanceSelection());
    setDisableAttendeeClicks(false);
    setDisablePaymentClicks(false);
    setDisableEditClicks(false);
  };

  const JAPAN_LOCAL_CHAPTER_NAME = 'japan';
  const isJapanLocalChapter =
    eventLocalChapterData?.name?.toLowerCase() === JAPAN_LOCAL_CHAPTER_NAME;

  const save = async (attendeeData) => {
    if (isSavingAttendee) return;

    try {
      setIsSavingAttendee(true);
      const emailTitle =
        ApplicationString['addAttendeeComponent.table.title.email']?.toLowerCase();
      const companyTitle =
        ApplicationString[
          'addAttendeeComponent.table.title.company'
        ]?.toLowerCase();
      const requiredFieldErrors = getRequiredAttendeeFieldErrors(form, {
        requireRegistrationOption: true,
        requireFood:
          eventType?.toLowerCase() !== 'webcast' && !eventISOnline,
        requireJapanFields: isJapanLocalChapter,
        messages: {
          firstName: ApplicationString['editableCell.pleaseFillOutFirstName'],
          lastName: ApplicationString['editableCell.pleaseFillOutLastName'],
          email: ApplicationString['editableCell.pleaseFillOut'](emailTitle),
          emailConfirm:
            ApplicationString['editableCell.pleaseConfirm'](emailTitle),
          registrationOption:
            ApplicationString['editableCell.pleaseSelectRegistrationOption'],
          foodOption: ApplicationString['editableCell.pleaseSelectFoodOption'],
          company: ApplicationString['editableCell.pleaseFillOut'](companyTitle),
          department: ApplicationString['editableCell.pleaseFillOut'](
            ApplicationString['editableCell.departmentDivision']?.toLowerCase(),
          ),
          jobTitle: ApplicationString['editableCell.pleaseFillOut'](
            ApplicationString['editableCell.jobTitleRole']?.toLowerCase(),
          ),
        },
      });
      if (requiredFieldErrors.length) {
        form.setFields(requiredFieldErrors);
        scrollAndFocusFormErrorField(requiredFieldErrors, form);
        setIsSavingAttendee(false);
        return;
      }

      const row = await form.validateFields();

      const Data = {
        ...row,
        event_id: id && parseInt(id),
        food_option:
          row.food_option === 'no-food' ||
          eventType?.toLowerCase() === 'webcast' ||
          eventISOnline
            ? {}
            : {
                type: 'food',
                event_option_id: row.food_option,
                qty: 1,
              },
        registration_option: {
          type: 'registration',
          event_option_id: row.registration_option,
          qty: 1,
        },
        registration_type: attendeeInPersonChecked ? 'In-Person' : 'Webcast',
      };

      if (isAddAttendee) {
        AddAttendee(
          Data,
          setEditingKey,
          form,
          setIsAddAttendee,
          setDisableAttendeeClicks,
          setDisablePaymentClicks,
          setDisableEditClicks,
          setIsSavingAttendee,
        );
      } else {
        const EditData = {
          ...row,
          food_option:
            row.food_option === 'no-food' ||
            eventType?.toLowerCase() === 'webcast' ||
            eventISOnline
              ? {}
              : {
                  type: 'food',
                  event_option_id: row?.food_option,
                  qty: 1,
                  id: attendeeData?.event_registration_options?.food?.id,
                },
          event_id: id && parseInt(id),
          registration_option: {
            type: 'registration',
            event_option_id: row?.registration_option,
            qty: 1,
            id: attendeeData?.event_registration_options?.registration?.id,
          },
          registration_type: attendeeInPersonChecked ? 'In-Person' : 'Webcast',
        };
        editAttendeeById(
          EditData,
          attendeeData.id,
          setEditingKey,
          form,
          setDisableAttendeeClicks,
          setDisablePaymentClicks,
          setDisableEditClicks,
          setIsSavingAttendee,
        );
      }
    } catch (errInfo) {
      setIsSavingAttendee(false);
      scrollAndFocusFormErrorField(errInfo, form);
    }
  };

  const addRow = () => {
    const existingAttendee = attendeesData.find((obj) =>
      Object.keys(newAttendee).every((key) => obj[key] === newAttendee[key]),
    );
    if (existingAttendee) {
      setDisableAttendeeClicks(true);
      return;
    } else {
      setIsAddAttendee(true);
      setAttendeeInPersonChecked(getDefaultAttendanceSelection());
      resetAttendanceDependentOptions(form, false);
      edit(newAttendee);
      setAttendeesData([...attendeesData, newAttendee]);
      setDisableEditClicks(true);
    }
  };
  const filterEmptyAttendeeData = attendeesData?.filter(
    (obj) => obj.id !== '1',
  );
  const onConfirm = useThrottle(async () => {
    if (allAttendeesData?.length <= 0 || disablePaymentClicks || qualificationConfirming) {
      dispatch({
        type: FETCH_ERROR,
        payload: 'Please save the attendee details first.',
      });
      return;
    }
    if (validatePaymentPrice(totalCartPrice?.discounted_price, dispatch)) {
      return;
    }

    // Refresh from API first so a prior Tally submit is recognized without
    // reopening the form from stale in-memory cart state.
    const latestAttendees =
      (await dispatch(fetchAttendeesForQualificationCheck(id))) ??
      allAttendeesData;

    const pendingQualifications = getPendingQualificationAttendees(
      latestAttendees,
      allEventOptionsRegistrationData,
    );

    if (pendingQualifications.length > 0) {
      const forms = pendingQualifications
        .map((attendee) => {
          const option = getRegistrationOptionMeta(
            attendee,
            allEventOptionsRegistrationData,
          );
          const url = toTallyEmbedUrl(
            buildTallyFormUrl(option?.tally_form_url, attendee),
          );
          return url ? {attendee, url} : null;
        })
        .filter(Boolean);

      if (forms.length !== pendingQualifications.length) {
        dispatch({
          type: FETCH_ERROR,
          payload: ApplicationString['qualificationForm.notConfirmedMessage'],
        });
        return;
      }

      sessionIdRef.current += 1;
      setTallySession({
        id: sessionIdRef.current,
        forms,
        index: 0,
      });
      return;
    }

    paymentByUserRegistration(id);
  }, 2000);

  tallySessionRef.current = tallySession;

  const closeTallyModal = () => {
    if (qualificationConfirming) return;
    sessionIdRef.current += 1;
    setTallySession(null);
  };

  const handleTallySubmitted = async () => {
    const session = tallySessionRef.current;
    if (!session || confirmingLockRef.current) return;
    const current = session.forms[session.index];
    if (!current) return;

    confirmingLockRef.current = true;
    setQualificationConfirming(true);
    setTallySession(null);
    const sessionId = session.id;
    try {
      let confirmed = await dispatch(
        pollQualificationStatus(id, [current.attendee.id]),
      );
      if (sessionIdRef.current !== sessionId) return;

      if (!confirmed) {
        const finalAttendees =
          (await dispatch(fetchAttendeesForQualificationCheck(id))) ?? [];
        if (sessionIdRef.current !== sessionId) return;
        const stillPending = getPendingQualificationAttendees(
          finalAttendees,
          allEventOptionsRegistrationData,
        );
        confirmed = !stillPending.some(
          (attendee) => Number(attendee.id) === Number(current.attendee.id),
        );
      }

      if (!confirmed) {
        dispatch({
          type: FETCH_ERROR,
          payload: ApplicationString['qualificationForm.notConfirmedMessage'],
        });
        return;
      }

      const nextIndex = session.index + 1;
      if (nextIndex < session.forms.length) {
        setTallySession({...session, index: nextIndex});
        return;
      }

      sessionIdRef.current += 1;
      setTallySession(null);
      paymentByUserRegistration(id);
    } finally {
      confirmingLockRef.current = false;
      setQualificationConfirming(false);
    }
  };

  const handleTallySubmittedRef = useRef(handleTallySubmitted);
  handleTallySubmittedRef.current = handleTallySubmitted;

  useEffect(() => {
    if (!tallySession) return undefined;
    const onMessage = (event) => {
      if (!isTallyFormSubmittedMessage(event)) return;
      handleTallySubmittedRef.current();
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [tallySession?.id]);

  const handleCancel = () => {
    navigate(`/eventDetails/${id}`);
  };

  useEffect(() => {
    const existingAttendee = attendeesData?.find((obj) =>
      Object.keys(newAttendee).every((key) => obj[key] === newAttendee[key]),
    );
    if (attendeesData?.length > 0 && existingAttendee) {
      setDisableAttendeeClicks(false);
    }
  }, [attendeesData]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  useEffect(() => {
    const newRow = {
      id: '1',
      name: '',
      email: '',
      eventid: '',
      price: '',
      registration_option: '',
      food_option: '',
      attendee_department: '',
      attendee_job_title: '',
    };
    const hasNewUnsavedRow = attendeesData?.some(
      (attendee) =>
        (!attendee.id || attendee.id === '' || attendee.id === '1') &&
        !attendee.attendee_first_name &&
        !attendee.attendee_last_name &&
        !attendee.attendee_email,
    );
    if (attendeesData && attendeesData?.length === 0) {
      setDisableAttendeeClicks(true);
      const loading = !attendeesData || attendeesData.length === 0;
      setLoading(loading);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setIsAddAttendee(true);
      setAttendeeInPersonChecked(getDefaultAttendanceSelection());
      resetAttendanceDependentOptions(
        form,
        getDefaultAttendanceSelection() === false,
      );
      edit(newRow);
      setAttendeesData([...attendeesData, newRow]);
    } else if (
      attendeesData &&
      attendeesData?.length > 0 &&
      !hasNewUnsavedRow
    ) {
      setIsAddAttendee(false);
      setDisableAttendeeClicks(false);
    }
  }, [attendeesData]);

  const hideInPersonCheckbox = () => {
    if (eventType?.toLowerCase() === 'webcast' || eventISOnline) {
      return true;
    } else if (!eventAvailableForWebcast?.isAvailable) {
      return true;
    } else {
      return false;
    }
  };

  const columns = [
    {
      title: ApplicationString['addAttendeeComponent.table.title.name'],
      dataIndex: 'name',
      key: 'name',
      editable: true,
      width: '15%',
      render: (text, record) => {
        return (
          <Tag prefixCls='regularAttendeesTag'>
            {record.attendee_first_name} {record.attendee_last_name}
          </Tag>
        );
      },
    },
    {
      title: ApplicationString['addAttendeeComponent.table.title.email'],
      dataIndex: 'attendee_email',
      key: 'email',
      width: '18%',
      editable: true,
      render: (text) => {
        return <Tag prefixCls='regularAttendeesTag'>{text}</Tag>;
      },
    },

    {
      title:
        ApplicationString['addAttendeeComponent.table.title.attendanceType'],
      dataIndex: 'registration_type',
      key: 'registration_type',
      hidden: hideInPersonCheckbox(),
      editable: true,
      width: 180,
      render: (text) => {
        return <h4 className='regularAttendees-price'>{text || 'N/A'}</h4>;
      },
    },
    {
      title: ApplicationString['addAttendeeComponent.table.title.option'],
      dataIndex: 'option',
      key: 'registration_and_food_option',
      width: '20%',
      editable: true,
      render: (_, record) => {
        const registrationName = record.registration_option?.name;
        const registrationPrice = record.registration_option?.price;
        const foodName =
          record.food_option?.name ||
          ApplicationString['addAttendeesComponent.label.noFoodOption'];

        const foodPrice = record.food_option?.price;
        return (
          <div className='option-tag-container'>
            <Tag prefixCls='regularAttendeesTag'>
              {ApplicationString['addAttendeeComponent.option.registration']}:{' '}
              {registrationName} -{' '}
              {formatCurrencyByLocalChapter(
                registrationPrice,
                eventLocalChapterData,
              )}
            </Tag>
            {(eventType !== 'Webcast' || eventISOnline) && (
              <Tag prefixCls='regularAttendeesTag'>
                {ApplicationString['addAttendeeComponent.option.food']}:{' '}
                {foodName}{' '}
                {foodPrice
                  ? '- ' +
                    formatCurrencyByLocalChapter(
                      foodPrice,
                      eventLocalChapterData,
                    )
                  : ''}
              </Tag>
            )}
          </div>
        );
      },
    },
    {
      title: ApplicationString['addAttendeeComponent.table.title.company'],
      dataIndex: 'attendee_company',
      key: 'company',
      width: '15%',
      editable: true,
      render: (text, record) => {
        const JAPAN_LOCAL_CHAPTER_NAME = 'japan';
        const isJapanLocalChapter =
          eventLocalChapterData?.name?.toLowerCase() ===
          JAPAN_LOCAL_CHAPTER_NAME;
        return (
          <div className='option-tag-container'>
            <Tag prefixCls='regularAttendeesTag'>{text}</Tag>
            {isJapanLocalChapter && (
              <>
                <Tag prefixCls='regularAttendeesTag'>
                  {record?.attendee_department || ''}
                </Tag>
                <Tag prefixCls='regularAttendeesTag'>
                  {record?.attendee_job_title || ''}
                </Tag>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: ApplicationString['addAttendeeComponent.table.title.price'],
      dataIndex: 'total_cost',
      width: '5%',
      render: (text) => {
        return (
          <h4 className='regularAttendees-price'>
            {formatCurrencyByLocalChapter(text, eventLocalChapterData)}
          </h4>
        );
      },
    },
    {
      title: ApplicationString['addAttendeeComponent.table.title.action'],
      dataIndex: 'action',
      width: '6%',
      fixed: 'right',
      render: (_, record) => {
        const isEditingRecord = record.id === editingKey;
        return (
          <AdminActionsDropdown
            record={record}
            usedForAttendeeTable={true}
            editBool={true}
            deleteBool={true}
            attendeeEditingKey={editingKey}
            handleCancelClick={cancel}
            handleSaveClick={save}
            handleEditClick={edit}
            handleDeleteClick={() => deleteAttendeeById(record.id)}
            isAddAttendee={isAddAttendee}
            disableEditClicks={disableEditClicks}
            disableSaveClicks={isSavingAttendee}
            setDisableEditClicks={setDisableEditClicks}
            setDisableAttendeeClicks={setDisableAttendeeClicks}
            setDisablePaymentClicks={setDisablePaymentClicks}
            text={ApplicationString[`userEventSponsorComponent.deleteText`]}
          />
        );
      },
    },
  ];
  const shouldEditCell = (column, record) => {
    if (column.dataIndex === 'registration_type') {
      return eventType?.toLowerCase() === 'webcast' || eventISOnline
        ? false
        : true;
    }

    return column.editable ? true : false;
  };
  const mergedColumns = columns
    .filter((column) => {
      return !column.hidden;
    })
    .map((col) => {
      return {
        ...col,
        onCell: (record) => ({
          record,
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record) && shouldEditCell(col, record),
          options: col.dataIndex,
        }),
      };
    });

  const handleOk = () => {
    setAttendeeInPersonChecked(true);
    resetAttendanceDependentOptions(form, false);
    setOpenConfirmationPopup(false);
  };
  const handlePopupCancel = () => {
    setAttendeeInPersonChecked(false);
    resetAttendanceDependentOptions(form, true);
    setOpenConfirmationPopup(false);
  };

  const currentTallyForm = tallySession?.forms?.[tallySession.index] ?? null;
  const tallyAttendeeName = [
    currentTallyForm?.attendee?.attendee_first_name,
    currentTallyForm?.attendee?.attendee_last_name,
  ]
    .filter(Boolean)
    .join(' ');
  const tallyModalTitle = tallyAttendeeName
    ? `${ApplicationString['qualificationForm.modalTitle']} — ${tallyAttendeeName}`
    : ApplicationString['qualificationForm.modalTitle'];

  return (
    <React.Fragment>
      <Modal
        width={860}
        centered
        destroyOnClose
        title={
          tallySession?.forms?.length > 1
            ? `${tallyModalTitle} (${tallySession.index + 1}/${tallySession.forms.length})`
            : tallyModalTitle
        }
        open={!!currentTallyForm}
        onCancel={closeTallyModal}
        footer={null}
        maskClosable={!qualificationConfirming}
        closable={!qualificationConfirming}
        className='qualification-form-modal'>
        <p className='qualification-form-hint'>
          {ApplicationString['qualificationForm.embedHint']}
        </p>
        {qualificationConfirming && (
          <Alert
            type='info'
            showIcon
            className='qualification-form-alert'
            message={ApplicationString['qualificationForm.confirmingMessage']}
            style={{marginBottom: 12}}
          />
        )}
        {currentTallyForm?.url && (
          <iframe
            key={`${currentTallyForm.attendee.id}-${tallySession.index}`}
            className='qualification-form-frame'
            title={tallyModalTitle}
            src={currentTallyForm.url}
          />
        )}
      </Modal>
      <Modal
        width={700}
        centered
        title={
          ApplicationString['addAttendeeComponent.button.webcastPopup.title']
        }
        open={openConfirmationPopup}
        onOk={handleOk}
        onCancel={handlePopupCancel}
        cancelText={
          ApplicationString['addAttendeeComponent.button.webcastPopup.confirm']
        }
        okText={
          ApplicationString['addAttendeeComponent.button.webcastPopup.inPerson']
        }
        footer={[
          <div className='button-attendance-container' key=''>
            <Button key='cancel' type='primary' onClick={handlePopupCancel}>
              {
                ApplicationString[
                  'addAttendeeComponent.button.webcastPopup.confirm'
                ]
              }
            </Button>
            <Button key='ok' type='primary' onClick={handleOk}>
              {
                ApplicationString[
                  'addAttendeeComponent.button.webcastPopup.inPerson'
                ]
              }
            </Button>
          </div>,
        ]}>
        <div className='confirm-popup-attendance-type'>
          <p>
            {
              ApplicationString[
                'addAttendeeComponent.button.webcastPopup.description'
              ]
            }
          </p>
        </div>
      </Modal>
      <Row gutter={[0, 16]} className='pbssMainContainerRow'>
        <div className='stickyEventName'>
          <SponsorOptionPageHeroText
            title={
              eventName ||
              ApplicationString['addAttendeeComponent.sponsor.heroText.title']
            }
            subTitle={
              ApplicationString[
                'addAttendeeComponent.sponsor.heroText.subtitle'
              ]
            }
          />
        </div>
        <Col span={24}>
          <SectionLayout>
            <div className='hero-subheading'>
              {
                ApplicationString[
                  'addAttendeeComponent.contactUsFormComponent.heading'
                ]
              }{' '}
              <a href='mailto:info@pbss.org'>
                {
                  ApplicationString[
                    'addAttendeeComponent.contactUsFormComponent.email'
                  ]
                }
              </a>{' '}
              {ApplicationString['userAddAttendeeComponent.message']}
            </div>
          </SectionLayout>
        </Col>
        <Col span={24}>
          <SectionLayout>
            <div className='addAttendees-button-wrapper'>
              <NavigationComponent
                name={
                  ApplicationString[
                    'userAddAttendeeComponent.goBackToEventDetails'
                  ]
                }
                urlPath={`eventDetails/${id}`}
              />
              <Button
                onClick={() => {
                  navigate(`/sponsorshipOption/${id}`);
                }}
                className='reg-navigation-btn'>
                {
                  ApplicationString[
                    'userAddAttendeeComponent.registerAs.sponsorText'
                  ]
                }
              </Button>
              <Button
                onClick={() => {
                  navigate(`/myEvents`);
                }}
                className='reg-navigation-btn'>
                {
                  ApplicationString[
                    'userAddAttendeeComponent.registerAs.myEvents'
                  ]
                }
              </Button>
            </div>
          </SectionLayout>
        </Col>
        {allEventOptionsRegistrationData &&
        allEventOptionsRegistrationData?.length > 0 ? (
          <>
            <Col span={24}>
              <SectionLayout>
                <Form
                  form={form}
                  onValuesChange={(changedValues) =>
                    formValueChangeHandler(form, changedValues)
                  }>
                  <Skeleton
                    loading={loading}
                    prefixCls='table-skeleton'
                    active
                    paragraph={{rows: attendeesData?.length}}>
                    <div className='attendees-label'>
                      {
                        ApplicationString[
                          'userAddAttendeeComponent.regularAttendee.label'
                        ]
                      }
                    </div>
                    <Table
                      prefixCls='attendees-table-container'
                      showExpandColumn={false}
                      components={{
                        body: {
                          cell: (props) => (
                            <EditableCell
                              allEventOptionsFoodData={allEventOptionsFoodData}
                              allEventOptionsRegistrationData={
                                allEventOptionsRegistrationData
                              }
                              eventType={eventType}
                              eventLocalChapterData={eventLocalChapterData}
                              eventISOnline={eventISOnline}
                              inPersonRemaining={inPersonRemaining}
                              attendeesData={attendeesData}
                              checkedAttendeeInPerson={attendeeInPersonChecked}
                              handleAttendeeInPersonChange={
                                handleAttendeeInPersonChange
                              }
                              {...props}
                            />
                          ),
                        },
                      }}
                      pagination={false}
                      scroll={{x: Math.max(columns?.length * 150, 1200)}}
                      dataSource={attendeesData}
                      columns={mergedColumns}
                    />
                  </Skeleton>
                </Form>
              </SectionLayout>
            </Col>
            <Col span={24}>
              <SectionLayout extendClass='addAttendeeWrapperEventUserComponent'>
                <AddAttendeeeComponent
                  disable={disableAttendeeClicks}
                  addRow={addRow}
                  setDisablePaymentClicks={setDisablePaymentClicks}
                />
              </SectionLayout>
            </Col>
            {filterEmptyAttendeeData?.length > 0 && (
              <Col span={24}>
                <SectionLayout>
                  <div className='attendees-payment-section'>
                    <div className='attendees-cart-coupon-container'>
                      <PromotionalCodeInputCart
                        title={
                          ApplicationString[
                            'userAttendeeCartComponent.couponCodeTitle'
                          ]
                        }
                        buttonText={
                          ApplicationString[
                            'userAttendeeCartComponent.couponCodeButtonText'
                          ]
                        }
                        onRedeemClick={(Data) => {
                          applyCouponCode({
                            ...Data,
                            eventId: parseInt(id),
                          });
                        }}
                        appliedCartCoupon={appliedCartCoupon}
                      />
                    </div>
                    {getPendingQualificationAttendees(
                      allAttendeesData,
                      allEventOptionsRegistrationData,
                    ).length > 0 && (
                      <Alert
                        type='info'
                        showIcon
                        className='qualification-form-alert'
                        message={
                          qualificationConfirming
                            ? ApplicationString[
                                'qualificationForm.confirmingMessage'
                              ]
                            : ApplicationString['qualificationForm.pendingAlert']
                        }
                        style={{marginBottom: 16}}
                      />
                    )}
                    <ConfirmationAction
                      heading={
                        ApplicationString[
                          'addAttendeeComponent.confirmationAction.heading'
                        ]
                      }
                      data={attendeesData}
                      submitName={
                        ApplicationString[
                          'addAttendeeComponent.confirmationAction.submitName'
                        ]
                      }
                      onConfirm={onConfirm}
                      onCancel={handleCancel}
                      totalCartPrice={totalCartPrice}
                      usedForCart
                      disable={disablePaymentClicks || qualificationConfirming}
                      extra={ApplicationString['attendee-screen-extra-message']}
                      eventLocalChapterData={eventLocalChapterData}
                    />
                  </div>
                </SectionLayout>
              </Col>
            )}
          </>
        ) : (
          <Col span={24}>
            <SectionLayout>
              <Alert
                message={ApplicationString['userNormalAttendee.alertMessage']}
                className='no-event-sponsor-alert'
                type='info'
                showIcon
              />
            </SectionLayout>
          </Col>
        )}
        {allRegistrationWaitingList?.length > 0 && (
          <Col span={24}>
            <SectionLayout>
              <WaitingList data={allRegistrationWaitingList} />
            </SectionLayout>
          </Col>
        )}

        <Col span={24}>
          <SectionLayout>
            <div className='add-attendee-accordion'>
              <div
                className={`add-attendee-accordion-item ${
                  addAttendeeAccordionOpen
                    ? 'add-attendee-accordion-item-open'
                    : ''
                }`}>
                <button
                  type='button'
                  className='add-attendee-accordion-header'
                  onClick={() =>
                    setAddAttendeeAccordionOpen(!addAttendeeAccordionOpen)
                  }
                  aria-expanded={addAttendeeAccordionOpen}>
                  <span className='add-attendee-accordion-question'>
                    {
                      ApplicationString[
                        'userAddAttendeeComponent.messageForWebcast.question'
                      ]
                    }
                  </span>
                  <span className='add-attendee-accordion-icon'>
                    {addAttendeeAccordionOpen ? (
                      <UpOutlined />
                    ) : (
                      <DownOutlined />
                    )}
                  </span>
                </button>
              </div>
              {addAttendeeAccordionOpen && (
                <div className='add-attendee-accordion-body'>
                  <p>
                    {
                      ApplicationString[
                        'userAddAttendeeComponent.messageForWebcast.answer1'
                      ]
                    }
                  </p>
                  <br />
                  <p>
                    {
                      ApplicationString[
                        'userAddAttendeeComponent.messageForWebcast.answer2'
                      ]
                    }
                  </p>
                  <br />
                  <p>
                    {
                      ApplicationString[
                        'userAddAttendeeComponent.messageForWebcast.answer3'
                      ]
                    }
                  </p>
                  <br />
                </div>
              )}
            </div>
          </SectionLayout>
        </Col>

        {currentLanguage !== LANGUAGES.JA && (
          <Col span={24}>
            <SectionLayout>
              <CustomCollapse />
            </SectionLayout>
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

export default AddAttendeeComponent;
